import React, { useEffect, useState, useCallback } from 'react';
import { InfoButton } from '~/components/layout/Buttons';
import HeaderDesktop from '~/components/layout/Header';
import SideBar from '~/components/layout/Sidebar';
import OpenChatBot from '~/components/layout/Chatbot';
import back from '~/assets/images/arrow.svg';
import api from '~/services/api';
import { dateFormatter } from '~/utils/formatters';
import {
  PageContainer,
  DivisionChangeName,
  DivisionButton,
  DivisionMobile,
  BackIcon,
  Content,
  IconLoading,
  HeaderContainer,
} from './styles';

import ReactTooltip from 'react-tooltip';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import { toast } from 'react-toastify';
import InsertName from '~/components/pages/ChangeName/InsertName';
import {
  clearDigitsSpecialChars,
  cellValidator,
  emailValidator,
  dateValidator,
} from '~/utils/parsers';
const inputsForm = [
  {
    label: 'Nome',
    value: 'name',
    type: '',
    disabled: false,
    limit: 100,
    limitPrint: 100,
  },
  {
    label: 'E-mail MAP',
    value: 'emailMap',
    type: '',
    disabled: true,
    limit: 256,
    limitPrint: 256,
  },
  {
    label: 'E-mail 2',
    value: 'email2',
    type: '',
    disabled: false,
    limit: 256,
    limitPrint: 256,
  },
  {
    label: 'Celular',
    value: 'cell',
    type: 'cell',
    disabled: false,
    limit: 16,
    limitPrint: 11,
    keyboard: 'tel',
  },
  {
    label: 'Telefone',
    value: 'phone',
    type: 'tel',
    disabled: false,
    limit: 14,
    limitPrint: 10,
    keyboard: 'tel',
  },
  {
    label: 'Data de Nascimento',
    value: 'birthDate',
    type: 'date',
    disabled: false,
    limit: 10,
    limitPrint: 8,
    keyboard: 'tel',
  },
  {
    label: 'Cargo',
    value: 'office',
    type: '',
    disabled: false,
    limit: 100,
    limitPrint: 100,
  },
];

export default function ChangeName() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [nameChanged, setNameChanged] = useState(false);
  const [dataChanged, setDataChanged] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [loading, setLoading] = useState({
    get: true,
    save: false,
  });
  const stores = useSelector(state => state.economicGroupReducer.stores);

  const [state, setState] = useState({
    name: '',
    emailMap: '',
    email2: '',
    phone: null,
    cell: null,
    birthDate: null,
    office: '',
  });

  const handleLoad = useCallback(
    (name, value) => {
      setLoading(sta => ({ ...sta, [name]: value }));
    },
    [setLoading],
  );

  const handleState = useCallback(
    (name, value) => {
      if (
        (name === 'cell' && value.length > 16) ||
        (name === 'phone' && value.length > 14) ||
        (name === 'birthDate' && value.length > 10) ||
        (name === 'name' && value.length > 100)
      )
        return;

      setState(sta => ({ ...sta, [name]: value }));
      if (name === 'name') setNameChanged(true);
      if (name !== 'name') setDataChanged(true);
    },
    [setState, setNameChanged, setDataChanged],
  );

  useEffect(() => {
    let cleanUp = false;
    const parameters = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      },
    };
    const contactId = localStorage.getItem('contactIdSf');
    const storeId = localStorage.getItem('storeId');
    async function asyncFunc() {
      try {
        const { data } = await api.get(
          `/residential/store/v1/stores/${storeId}/contacts/${contactId}`,
          parameters,
        );
        if (cleanUp) return;
        const cellNumber =
          (data.cellPhoneNumber &&
            clearDigitsSpecialChars(data.cellPhoneNumber).length === 9) ||
          clearDigitsSpecialChars(data.cellPhoneNumber).length < 8
            ? clearDigitsSpecialChars(data.cellPhoneNumber)
            : '9' + clearDigitsSpecialChars(data.cellPhoneNumber);
        const cell =
          data.cellPhoneAreaCode &&
          data.cellPhoneNumber &&
          data.cellPhoneAreaCode + cellNumber;
        const phone =
          data.landlinePhoneAreaCode &&
          data.landlinePhone &&
          data.landlinePhoneAreaCode +
            clearDigitsSpecialChars(data.landlinePhone);
        const name = localStorage.getItem('userName');
        const birthDate =
          data.birthDate && data.birthDate.split('-').reverse().join('');
        const bodyForm = {
          name,
          emailMap: data.email,
          email2: data.secondaryEmail,
          phone,
          cell,
          birthDate,
          office: data.position,
        };
        setState(bodyForm);
        handleLoad('get', false);
      } catch (error) {
        toast.error('Erro ao buscar dados do perfil');
        history.goBack();
      }
    }
    asyncFunc();
    return () => (cleanUp = true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();
      if (!isEditable) {
        setIsEditable(true);
        return;
      }
      let parameters = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          access_token: localStorage.getItem('access_token'),
        },
      };
      const contactId = localStorage.getItem('contactIdSf');
      const storeId = localStorage.getItem('storeId');
      const dataState = {
        ...state,
        cell: clearDigitsSpecialChars(state.cell).substring(0, 11),
        phone: clearDigitsSpecialChars(state.phone).substring(0, 10),
        birthDate: dateFormatter(state.birthDate),
      };

      let errors = [];
      if (!dataState.name) {
        errors.push('Campo nome não pode ser vazio');
      }
      if (
        !dataState.email2 &&
        !dataState.phone &&
        !dataState.cell &&
        !dataState.birthDate
      ) {
        errors.push(
          'Preencha ao menos um desses campos: Celular, E-mail 2, Data de nascimento ou Telefone',
        );
      } else {
        if (!!dataState.cell && dataState.cell.length !== 11) {
          errors.push('Insira um número de celular válido');
        }

        if (!!dataState.email2 && !emailValidator(dataState.email2)) {
          errors.push('Insira um email válido');
        }

        if (!!dataState.phone && dataState.phone.length !== 10) {
          errors.push('Insira um número de telefone válido');
        }

        if (!!dataState.birthDate) {
          if (!dateValidator(dataState.birthDate)) {
            errors.push('Insira uma data válida');
          } else {
            let currentYear = new Date();
            currentYear = Number(currentYear.getFullYear());
            const birthYear = Number(dataState.birthDate.substring(6));
            const result = currentYear - birthYear;

            if (result < 18 || result > 100) {
              errors.push('Insira uma data válida');
            }
          }
        }
      }

      if (errors.length > 0) {
        errors.forEach(item => {
          toast.error(item);
        });
        handleLoad('save', false);
        return;
      }

      try {
        const cell = dataState.cell;
        const phone = dataState.phone;
        const cellPhoneAreaCode = cell.substring(0, 2);
        const cellPhoneNumber = cell.substring(2);
        const landlinePhoneAreaCode = phone.substring(0, 2);
        const landlinePhone = phone.substring(2);
        const birthDate =
          dataState.birthDate &&
          dataState.birthDate.split('/').reverse().join('-');
        const data = {
          cellPhoneAreaCode,
          cellPhoneNumber,
          landlinePhoneAreaCode,
          landlinePhone,
          secondaryEmail: dataState.email2,
          birthDate,
          position: dataState.office,
        };
        if (!cell) {
          delete data.cellPhoneAreaCode;
          delete data.cellPhoneNumber;
        }

        if (!phone) {
          delete data.landlinePhoneAreaCode;
          delete data.landlinePhone;
        }

        if (!data.secondaryEmail) {
          delete data.secondaryEmail;
        }

        if (!data.birthDate) {
          delete data.birthDate;
        }

        if (!data.position) {
          delete data.position;
        }

        if (dataChanged) {
          await api.put(
            `/residential/store/v1/stores/${storeId}/contacts/${contactId}`,
            data,
            parameters,
          );
          setDataChanged(false);
        }
        if (nameChanged) {
          parameters.method = 'PATCH';
          const userId = localStorage.getItem('userId');
          const body = { name: dataState.name };
          await api.patch(
            `/residential/store/v1/users/me/contacts`,
            body,
            parameters,
          );
          localStorage.setItem('userName', dataState.name);
          setNameChanged(false);
        }
        toast.success('Dados alterados com sucesso');
      } catch (error) {
        console.warn(error);
      } finally {
        handleLoad('save', false);
        setIsEditable(false);
      }
    },
    [
      state,
      api,
      toast,
      cellValidator,
      emailValidator,
      dateValidator,
      dateFormatter,
      nameChanged,
      dataChanged,
      setDataChanged,
      setNameChanged,
      setIsEditable,
      isEditable,
      handleLoad,
    ],
  );

  if (loading.get) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100%',
        }}
      >
        <IconLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
      </div>
    );
  }
  return (
    <PageContainer>
      <SideBar menuSelected={'Minha Conta'}>
        <HeaderContainer>
          <HeaderDesktop stores={stores} />
        </HeaderContainer>
        <DivisionChangeName>
          <DivisionMobile>
            <BackIcon
              to="/portal"
              onClick={() => {
                dispatch({ type: 'ORDER_DONE' });
              }}
            >
              <img src={back} alt="Ícone para voltar" />
            </BackIcon>
          </DivisionMobile>
          <Content>
            <h3 style={{ marginBottom: 30 }}>
              <CreateOutlinedIcon
                style={{
                  width: '1em',
                  margin: '0 .3rem .3rem .3rem',
                }}
              />
              Editar meu perfil
            </h3>
            <form onSubmit={handleSubmit}>
              {inputsForm.map(item => (
                <InsertName
                  key={item.label}
                  item={item}
                  value={state[item.value]}
                  onChange={handleState}
                  isEditable={isEditable}
                />
              ))}
              <DivisionButton>
                <InfoButton
                  type="submit"
                  onClick={() => {
                    if (isEditable) {
                      handleLoad('save', true);
                    }
                  }}
                  disabled={localStorage.getItem('ownerid')}
                  data-tip={localStorage.getItem('ownerid') ? "A função de edição dos seus dados não está disponível no momento. Para atualização cadastral, contate o titular da conta." : ""}
                  data-for="editTooltip"
                  style={{
                    backgroundColor: localStorage.getItem('ownerid') && 'gray',
                    cursor: localStorage.getItem('ownerid') && 'not-allowed',
                  }}
                >
                  {loading.save ? (
                    <IconLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                  ) : isEditable ? (
                    'Salvar'
                  ) : (
                    'Editar'
                  )}
                </InfoButton>
                {localStorage.getItem('ownerid') && (
                  <ReactTooltip id="editTooltip" place="top" effect="solid" />
                )}
              </DivisionButton>
            </form>
          </Content>
        </DivisionChangeName>
        <OpenChatBot />
      </SideBar>
    </PageContainer>
  );
}
